import I18n from 'i18n-js';

import InfoIcon from '~/components/atoms/Icons/InfoIcon';
import ButtonClean from '~/components/ButtonClean';

import { TUseBooleanFunction } from '~/hooks/useBooleanState';

import styles from './CollectionRankingHeader.module.scss';

export function CollectionRankingHeader({
  onIconClick,
  onShowMoreClick,
}: {
  onIconClick: TUseBooleanFunction;
  onShowMoreClick: TUseBooleanFunction;
}): JSX.Element {
  return (
    <>
      <div className={styles.rankingHeader}>
        <h3 className={styles.rankingHeadline}>
          {I18n.t('collections_ranking_headline')}
        </h3>
        <InfoIcon
          className={styles.infoButton}
          onClick={onIconClick}
          background={false}
        />
        <ButtonClean
          className={styles.openRankingButton}
          onClick={onShowMoreClick}
        >
          {I18n.t('common_show_more')}
        </ButtonClean>
      </div>
    </>
  );
}
